"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
function confirm() {
  _antd.message.success('Click on Yes');
}
function cancel() {
  _antd.message.error('Click on No');
}
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Popconfirm._InternalPanelDoNotUseOrYouWillBeFired, {
    title: "Are you sure to delete this task?",
    onConfirm: confirm,
    onCancel: cancel,
    okText: "Yes",
    cancelText: "No",
    placement: 'topLeft'
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorBgElevated', 'colorWarning'],
  key: 'default'
};
var _default = exports.default = componentDemo;